import type { IAdminInvitationRepository } from "@/application/ports/repositories";
import type { AdminInvitation, InvitationCreateRequest } from "@/domain/admin";
import { apiClient } from "../client";

export class AdminInvitationRepository implements IAdminInvitationRepository {
	private basePath = "/admin/invitations";

	async createInvitation(
		data: InvitationCreateRequest,
	): Promise<AdminInvitation> {
		const response = await apiClient.post<AdminInvitation>(this.basePath, data);
		return response.data;
	}
	async resendInvitation(uuid: string): Promise<AdminInvitation> {
		const response = await apiClient.patch<AdminInvitation>(
			`${this.basePath}/${uuid}/resend`,
		);
		return response.data;
	}
	async cancelInvitation(uuid: string): Promise<void> {
		await apiClient.delete(`${this.basePath}/${uuid}`);
	}
}
